import _schedules                          from './schedules';

export default class {
  static schedules = _schedules;
}